export const domainCountry = import.meta.env.VITE_COUNTRY;
export function init() {
    window.domainCountry = domainCountry;
}
init();